import React, { useState } from 'react';
import { Lock, Menu, PlusCircle, Search, X } from 'lucide-react';

export const Navbar = ({ view, setView, setTrackedId }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-slate-900 text-white shadow-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo e Título */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => { setView('public'); setTrackedId(null); }}>
          <img src="https://i.postimg.cc/hjqs4KF5/RTA.jpg" alt="RTA Logo" className="h-10 bg-white p-1 rounded object-contain" />
          <div>
            <h1 className="font-bold text-base sm:text-lg leading-tight">Canal de Integridade</h1>
            <span className="hidden sm:block text-xs text-slate-400">Ambiente Seguro e Confidencial</span>
          </div>
        </div>

        {/* Menu Desktop */}
        <div className="hidden md:flex flex-wrap justify-center gap-6">
          <button onClick={() => { setView('public'); setTrackedId(null); setIsMenuOpen(false); }} className={`text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'public' ? 'text-blue-400' : 'text-slate-300'}`}><PlusCircle size={16} /> Novo Relato</button>
          <button onClick={() => { setView('track'); setIsMenuOpen(false); }} className={`text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'track' ? 'text-blue-400' : 'text-slate-300'}`}><Search size={16} /> Acompanhar Situação</button>
          <button onClick={() => { setView('admin'); setIsMenuOpen(false); }} className={`text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'admin' ? 'text-blue-400' : 'text-slate-300'}`}><Lock size={16} /> Painel Admin</button>
        </div>

        {/* Botão Menu Hambúrguer (Apenas Celular) */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-slate-300 hover:text-white p-1">
            {isMenuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Menu Dropdown Celular */}
      {isMenuOpen && (
        <div className="md:hidden bg-slate-800 border-t border-slate-700 px-4 pt-2 pb-4 space-y-2 shadow-inner animate-fadeIn">
          <button onClick={() => { setView('public'); setTrackedId(null); setIsMenuOpen(false); }} className={`w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'public' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`}><PlusCircle size={18} /> Novo Relato</button>
          <button onClick={() => { setView('track'); setIsMenuOpen(false); }} className={`w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'track' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`}><Search size={18} /> Acompanhar Situação</button>
          <button onClick={() => { setView('admin'); setIsMenuOpen(false); }} className={`w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'admin' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`}><Lock size={18} /> Painel Admin</button>
        </div>
      )}
    </nav>
  );
};
